import { useRef } from 'react';

var useLazyRef = function (init) {
    var ref = useRef();
    if (!ref.current) {
        ref.current = init();
    }
    return ref;
};

export { useLazyRef as default };
